import { useNavigate } from "react-router-dom"

export const ExaminationPreparation = () => {
    const Navigate = useNavigate()
    return (
        <>
            <div className="row col-lg-11 ExaminationPreparation_bg mx-auto my-5 img_move" >
                <div className="col-12 col-lg-4  d-flex justify-content-center ps-lg-5" style={{ flexDirection: 'column' }} >
                    <h2
                        className="text-white fw-bold"
                        title="Student Registration"
                    >
                        Preparation for Insurance Professional Examinations
                    </h2>
                    {/* <h4 className="text-white fw-bold"> for  </h4>
                    <h2 className="display-6 fw-bold text-white mb-4"> Examination </h2> */}

                    <button className="btn btn-1 hover-filled-slide-left mt-3" onClick={() => Navigate('ExaminationStructure')}>
                        <span>Click Here</span>
                    </button>

                    {/* <button className="btn services_bg_color mt-3 w-50" type="submit">Click Here</button> */}

                </div>
            </div>

        </>
    )
}